import PropTypes from "prop-types";
import "./nonRecyclableBid-popup.css";
import { Modal } from "antd";
import ConfirmationModalStopImg from "../../assets/img/svg/xstopalert.svg";

const NonRecyclableBidPopup = (props) => {
    return (
        <>
            <Modal
                title={
                    props.clickFor === "Ready Status" ? (
                        <span style={{ WebkitTextFillColor: '#03b603', paddingTop: "5rem"}}>
                            {props.title}
                        </span>
                    ) : (
                        props.title
                    )
                } open={props.open}
                onCancel={props.handleCloseHandler}
                footer={null}
                className="recycle-manifest-model stop-modal size-30"
                width={760}
                centered
            >
                {props.clickFor === "Ready Status" ? <div className="modal-header-img"><svg width="233" height="129" viewBox="0 0 233 129" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse opacity="0.3" cx="113.171" cy="113.825" rx="113.171" ry="113.825" transform="matrix(0.889167 0.457582 -0.46183 0.886968 65.4961 -139.898)" fill="url(#paint0_linear_4954_32649)" fill-opacity="0.2" />
                    <ellipse opacity="0.3" cx="78.5699" cy="78.9399" rx="78.5699" ry="78.9399" transform="matrix(0.924999 0.379968 -0.387225 0.921985 71.2773 -89.457)" fill="url(#paint1_linear_4954_32649)" fill-opacity="0.2" />
                    <g filter="url(#filter0_dd_4954_32649)">
                        <rect x="82.668" y="13" width="60.9375" height="60.9375" rx="30.4688" fill="#22C55E" />
                        <path d="M103 44 L110.5 51.5 L124 36" stroke="white" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                    </g>
                    <defs>
                        <filter id="filter0_dd_4954_32649" x="46.5005" y="-23.1675" width="142.707" height="142.707" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dx="4.7175" dy="4.7175" />
                            <feGaussianBlur stdDeviation="8.25562" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.583966 0 0 0 0 0 0 0 0 0.16 0" />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4954_32649" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dx="4.7175" dy="4.7175" />
                            <feGaussianBlur stdDeviation="20.4425" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.639386 0 0 0 0 0 0 0 0 0.26 0" />
                            <feBlend mode="normal" in2="effect1_dropShadow_4954_32649" result="effect2_dropShadow_4954_32649" />
                            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4954_32649" result="shape" />
                        </filter>
                        <linearGradient id="paint0_linear_4954_32649" x1="72.8319" y1="13.4217" x2="103.372" y2="200.6" gradientUnits="userSpaceOnUse">
                            <stop stop-color="white" stop-opacity="0.3" />
                            <stop offset="1" stop-color="#22C55E" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_4954_32649" x1="50.5641" y1="9.30818" x2="71.7229" y2="139.127" gradientUnits="userSpaceOnUse">
                            <stop stop-color="white" stop-opacity="0.3" />
                            <stop offset="1" stop-color="#22C55E" />
                        </linearGradient>
                    </defs>
                </svg></div> : <img
                    src={ConfirmationModalStopImg}
                    alt="Modal Stop"
                    className="modal-header-img"
                />}
                <span
                    style={
                        props.clickFor === "TBI Status"
                            ? { marginTop: "10px" }
                            : props.clickFor === "Ready Status"
                                ? { margin: "0 62px" , color: "#004677", fontWeight:"600"}
                                : { margin: "20px 0" }
                    }
                >
                    {props.subContent}
                </span>
                {props.clickFor === "TBI Status" ? props?.rackselfInput : null}
                {props.clickFor === "Ready Status" ? (

                    <div
                        className="book-page-buttons-container"
                        style={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                        }}
                    >
                        <button
                            className="accept-button"
                            type="submit"
                            style={{ margin: "10px", width: "120px" }}
                            onClick={props?.onOKClick}
                        >
                            OK
                        </button>
                    </div>
                ) : props.clickFor !== "TBI Status" ? (

                    <div
                        className="book-page-buttons-container"
                        style={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                        }}
                    >
                        <button
                            style={{
                                margin: "10px",
                                borderColor: "#29acd5",
                                width: "120px",
                                color: "#29acd5",
                            }}
                            className="modal-cancel-button"
                            type="button"
                            onClick={props?.handleCloseHandler}
                        >
                            Close
                        </button>
                        <button
                            className="accept-button"
                            type="submit"
                            style={{ margin: "10px", width: "120px" }}
                            onClick={props?.onOKClick}
                        >
                            OK
                        </button>
                    </div>
                ) : null}
            </Modal>
        </>
    );
};

NonRecyclableBidPopup.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool.isRequired,
    handleCloseHandler: PropTypes.func.isRequired,
    clickFor: PropTypes.string,
    subContent: PropTypes.node,
    rackselfInput: PropTypes.node,
    onOKClick: PropTypes.func,
};

NonRecyclableBidPopup.defaultProps = {
    title: "",
    clickFor: "",
    subContent: null,
    rackselfInput: null,
    onOKClick: undefined,
};

export default NonRecyclableBidPopup;